import {Component} from '@angular/core';
import {NgIcon, provideIcons} from '@ng-icons/core';
import {matChevronRightRound, matKeyboardArrowDownRound} from '@ng-icons/material-icons/round';
import {Button} from 'primeng/button';
import {NavigatorDirective} from '../../../shared/directive/navigator.directive';
import {formComponentSignal} from '../../../shared/signal/common/form-component.signal';
import {GoogleAnalyticsService} from '../../../shared/analytics/google/google-analytics.service';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../../shared/enum/gtm-cookie-consent.enum';
import {Theme} from '../../../shared/enum/theme.enum';
import {PixelService} from '../../../shared/analytics/meta/pixel.service';
import {PixelEventName} from '../../../shared/analytics/meta/types/pixel.types';
import {MicrosoftClarityService} from '../../../shared/analytics/microsoft/microsoft-clarity.service';
import {MicrosoftClarityEvents} from '../../../shared/analytics/microsoft/types/microsoft-clarity-events.enum';
import {
  MicrosoftClaritySessionBumper
} from '../../../shared/analytics/microsoft/types/microsoft-clarity-session-bumper.enum';

@Component({
  selector: 'app-parking-logistics',
  imports: [
    NgIcon,
    Button,
    NavigatorDirective
  ],
  templateUrl: './parking-logisitcs.component.html',
  styleUrl: './parking-logisitcs.component.scss',
  providers: [provideIcons({
    matChevronRightRound,
    matKeyboardArrowDownRound
  })]
})
export class ParkingLogisitcsComponent {
  protected readonly formComponentSignal = formComponentSignal;

  steps = [
    {
      title: $localize`:@@autopark.logistics.step-1.title:Zgłoszenie`,
      description: $localize`:@@autopark.logistics.step-1.description:Zgłoszenie dostawy/odbioru e-mailem najpóźniej w dniu operacji`
    },
    {
      title: $localize`:@@autopark.logistics.step-2.title:Przyjęcie pojazdu`,
      description: $localize`:@@autopark.logistics.step-2.description:Po przyjeździe wskazujemy sektor parkowania.`
    },
    {
      title: $localize`:@@autopark.logistics.step-3.title:Magazynowanie`,
      description: $localize`:@@autopark.logistics.step-3.description:Pojazd trafia w wyznaczone miejsce — porządek i pełna kontrola.`
    },
    {
      title: $localize`:@@autopark.logistics.step-4.title:Szybkie wydanie`,
      description: $localize`:@@autopark.logistics.step-4.description:Minimalny czas postoju, maksymalna sprawność logistyki.`
    }
  ];

  constructor(
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly pixelService: PixelService,
    private readonly microsoftClarityService: MicrosoftClarityService) {
  }

  protected onCtaClick(): void {
    this.googleAnalyticsService.trackEvent({
      event: AnalyticsEventName.RequestCtaClick,
      eventCategory: AnalyticsEventCategory.CTA,
      eventPayload: Theme.PARKING
    });

    this.pixelService.trackEvent(PixelEventName.RequestCta, {
      page: Theme.PARKING
    });

    this.microsoftClarityService.trackEvent(
      MicrosoftClarityEvents.RequestCta
    );

    this.microsoftClarityService.upgradeSession(MicrosoftClaritySessionBumper.RequestCtaClicked)
  }
}
